import React, {Component} from 'react';
import Popup from '../../Popup';
import Grid from '@mui/material/Grid2';
import AlertIcon from "@assets/icons/alert-icon.svg";
class RepeatedSkillPopup extends Component {
    constructor(props) {
        super(props);this.state = {}
    }
    render() {
        return (
          <Popup show closeButton onClose={()=>this.props.hidePopup('showRepeatedPopup')}>
            <Grid container>
              <Grid size={1} className='justify-content-center'>
                  <img src={AlertIcon} className='mx-auto' alt=''/>
              </Grid>
              <Grid size={11} className='justify-content-center mt-5'>
                  <span className='mx-auto'>{this.props.lan.addedRepeatedSkill}</span>
              </Grid>
            </Grid>
          </Popup>
        );
    }
}

export default RepeatedSkillPopup;
